/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import Close16 from '@carbon/icons-react/lib/close/24';
import { RadioButtonSkeleton } from 'carbon-components-react';
import { Link } from 'react-router-dom';
import { api } from '../../helpers/api/api';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { NotificationModule } from '../../helpers/Constants';


export class Notification extends Component {


  constructor(props) {
    super(props);

    this.state = {
      notifications: [],
      isLoad: true
    };
    this.getNotifications = this.getNotifications.bind(this);
    this.deletenotification = this.deletenotification.bind(this);
    this.getColorModule = this.getColorModule.bind(this);
  }

  componentDidMount() {
    this.getNotifications();
  }

  getNotifications = () => {
    this.setState({
      isLoad: true
    });
    api.getAll('/notifications').then((response) => {
      this.setState({
        notifications: response.data,
        isLoad: false
      });
    });
  };

   deletenotification = async (id) => {
    this.setState((prevState) => ({
        isLoad: true,
      notifications: prevState.notifications.filter((x) => x.id !== id)
    }));
      await this.props.isDeleted();

    api.delete('/notifications/', id).then((response) => {
      this.setState(
        {isLoad: false},this.props.isOpenNotification
      );
    });
  };

  getColorModule(id) {
    const entity = (this.state.notifications || []).find((el) => el.id == id);

    if (entity.moduleName == NotificationModule.ModuleAudit) {
      return 'module--audit';
    }
    if (entity.moduleName == NotificationModule.ModuleReport) {
      return 'module--report';
    }
    if (entity.moduleName == NotificationModule.ModuleIncident) {
      return 'module--incident';
    }
    if (entity.moduleName == NotificationModule.ModuleHocCards) {
      return 'module--hoccards';
    }
    if (entity.moduleName == NotificationModule.ModuleInspection) {
      return 'module--inspection';
      }
      if (entity.moduleName == NotificationModule.ModuleDrill) {
          return 'module--drill';
      }
      if (entity.moduleName == NotificationModule.ModuleTraining) {
          return 'module--training';
      }
    return '';
  }

    render() {
        return (
            <div className="notification-box">
                {this.state.notifications != null && this.state.notifications.length > 0 ? (
                    <div className="notification-dot notification-dot-lager">
                        <span className="notification-span notification-span-larger">
                            {this.state.notifications.length < 99 ? this.state.notifications.length : '99'}
                        </span>
                    </div>
                ) : null}
                {this.props.isOpen ? (
                    <div className="notification-items">
                        <div className="notification--items  notification--items-all">
                            {this.state.notifications == null || this.state.notifications.length == 0 ? (
                                this.state.notifications == null ||
                                    (this.state.notifications.length == 0 && this.state.isLoad == true) ? (
                                        <LoadNotification />
                                    ) : (
                                        <NoRecordsNotification />
                                    )
                            ) : (
                                    this.state.notifications.map((notification) => (
                                       
                                        <div className="notification-item  notification">
                                            {notification.reference != null ? (
                                                <Link to={notification.reference}>
                                                    <div className="notification-information">
                                                        <div className="expandable">
                                                            <div className="notification--date">
                                                                {' '}
                                                                {switchDateFormat(notification.dateTime, 'datetime')}
                                                            </div>
                                                        </div>

                                                        <div className="notification-module">
                                                            <span className={this.getColorModule(notification.id)}>
                                                                {notification.moduleName != null ? notification.moduleName : ''}
                                                            </span>
                                                            <span title={notification.body} className="">{notification.body}</span>
                                                        </div>

                                                        <p className="notification--operator">
                                                            {notification.originatingUser != null
                                                                ? notification.originatingUser.name
                                                                : null}
                                                        </p>
                                                    </div>
                                                </Link>
                                            ) : (
                                                    ''
                                                )}
                                            <div className="notification-actions hoverable">
                                                <Close16
                                                    onClick={() => this.deletenotification(notification.id)}
                                                    key={`delete-${notification.id}`}
                                                    size="small"
                                                    iconDescription="Edit"
                                                    kind="ghost"
                                                />
                                            </div>
                                            </div> 
                                    ))
                                )}
                        </div>
                    </div>
                ) : null}
            </div>
      
    );
  }
}
function LoadNotification() {
  return (
    <div className="notification-item  notification ">
      <div className="notification-not-found">
        <RadioButtonSkeleton />
      </div>
    </div>
  );
}

function NoRecordsNotification() {
  return (
    <div className="notification-item  notification ">
      <div className="notification-not-found">
        <p>No Notifications Found</p>
      </div>
    </div>
  );
}
